import MentionsLegales from "../mentionslegals/mentionslegals";

const Main = () => {
  return (
    <section className="ml-section" id="main">
      <MentionsLegales />
    </section>
  );
};

export default Main;
